import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    // 建議優先綁在 #root（你要完全接手勢的最外層）
    const target = document.getElementById("root") || document;

    const onTouchMove = (e: TouchEvent) => {
      // 多指時攔下（雙指捏合、三指手勢）
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // iOS Safari 舊式手勢事件，保險也封鎖
    const blockGesture = (e: Event) => e.preventDefault();

    target.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("gesturestart", blockGesture as EventListener, {
      passive: false,
    });
    document.addEventListener("gesturechange", blockGesture as EventListener, {
      passive: false,
    });

    return () => {
      target.removeEventListener("touchmove", onTouchMove as EventListener);
      document.removeEventListener(
        "gesturestart",
        blockGesture as EventListener
      );
      document.removeEventListener(
        "gesturechange",
        blockGesture as EventListener
      );
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        {/* 外層容器：由你接管觸控，避免預設手勢干擾 */}
        <div className="touch-none select-none overscroll-contain overflow-hidden h-dvh w-dvw">
          <Toaster />
          <Sonner />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
